import React from 'react';
import { type ListingUILabel } from '3-components/ListingApp/ListingUI/ListingUI';

export type AppStatus = 'initial-loading' | 'fetching' | 'initial-error' | 'error' | 'ready';

export interface SearchBlockLabel extends ListingUILabel {
    noValueSearchForLabel: string;
    withValueSearchForLabel: string;
}

export interface SearchBlockCMSConfig {
    apiKey: string;
}

export interface TagsLabelItem {
    value: string;
    label: string;
}

export interface SearchBlockProps {
    label: ListingUILabel;
    searchResultsPerPage: number;
    apiUrl: string;
}

export type SearchBlockContextProps = SearchBlockProps

const SearchBlockContext = React.createContext<Partial<SearchBlockContextProps>>({});

export default SearchBlockContext;
